<template>
  <v-card
    id="encours"
    fluid
  >



    <v-card>
      <v-card-title class="text-subtitle-2 blue darken-3 white--text">
        <v-row align=" baseline">
          <v-col cols="12" md="3">
            <span>
              {{ this.ot_encours.name }}
            </span>
          </v-col>
          <v-col cols="12" md="9" align="right">
            <span>
              {{ this.ot_encours.mission }}
            </span>
          </v-col>
        </v-row>
      </v-card-title>
    </v-card>

    <v-card> 
      <v-row align="baseline">
        <v-col cols="12" md="3">
          <v-text-field
            label="Objet"
            v-model="this.ot_encours.objet"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            label="Alpha"
            v-model="this.ot_encours.alpha"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            v-model="this.ot_encours.delta"
            label="Delta"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            v-model="this.ot_encours.magv"
            label="MagV"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card>


    <v-card v-if="b_NARVAL" >
      <v-card-title class="text-subtitle-2 blue lighten-3 black--text">
        <v-row align="baseline">
          <v-col cols="12" md="2">
            <div class="text-subtitle-2">
              Visible
            </div>
              
          </v-col>
          <v-col cols="12" md="2">
            <div v-if="this.ot_encours.vis_fabryperot" class="red--text">

              Fabry-Perot ON

            </div>
            <div v-if="!this.ot_encours.vis_fabryperot" class="grey--text">

              Fabry-Perot OFF

            </div>
          </v-col>
          <v-col cols="12" md="8" align="right">
              Temps Exécution (NARVAL): {{ this.ot_encours.vis_runing_time | formatDuration }}
          </v-col>
        </v-row>
      </v-card-title>
      <v-card>

        <v-row align="baseline">
          <v-col cols="12" md="3">
            <v-text-field
              label="Mode"
              v-model="this.ot_encours.vis_mode"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              label="cam Mode"
              v-model="this.ot_encours.vis_mode_l"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="this.ot_encours.vis_sn"
              label="S/N"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="this.ot_encours.vis_exp"
              label="Temps de Pose (s)"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">A Faire : </v-col>
          <v-col cols="12" md="9">
            {{this.ot_encours.vis_ntimesrepeate}} x (  {{this.ot_encours.vis_n_pose}} x Stokes {{ this.ot_encours.vis_stokes }} (4 poses x {{this.ot_encours.vis_exp}}s) )
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">Fait : </v-col>
          <v-col cols="12" md="9">
        </v-col>
        </v-row>
      </v-card>
    </v-card>

    <v-card v-if="b_SPIP">
      <v-card-title class="text-subtitle-2 red darken-4 white--text">
        <v-row align="baseline">
          <v-col cols="12" md="2">
            <span>
              InfraRouge
            </span>
          </v-col>
          <v-col cols="12" md="2">
            <div v-if="this.ot_encours.ir_fabryperot" class="blue--text">

              Fabry-Perot ON

            </div>
            <div v-if="!this.ot_encours.ir_fabryperot" class="grey--text">

              Fabry-Perot OFF

            </div>
          </v-col>
          <v-col cols="12" md="8" align="right">
              Temps Exécution (SPIP): {{ this.ot_encours.ir_runing_time | formatDuration }}
          </v-col>        
        
        </v-row>
      </v-card-title>


      <v-card>

        <v-row align="baseline">
          <v-col cols="12" md="3">
            <v-text-field
              label="Mode"
              v-model="this.ot_encours.ir_mode"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="this.ot_encours.ir_sn"
              label="S/N"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="this.ot_encours.ir_exp"
              label="Temps de Pose (s)"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">A Faire : </v-col>
          <v-col cols="12" md="9">
            <div v-if="this.ot_encours.ir_stokes == 'I'">
            {{this.ot_encours.ir_ntimesrepeate}} x (  Stokes {{ this.ot_encours.ir_stokes }} (1 poses x {{this.ot_encours.ir_exp}}s) )
            </div>
            <div v-else>
            {{this.ot_encours.ir_ntimesrepeate}} x (  Stokes {{ this.ot_encours.ir_stokes }} (4 poses x {{this.ot_encours.ir_exp}}s) )
            </div>            
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">Fait : </v-col>
          <v-col cols="12" md="9">
        </v-col>
        </v-row>
      </v-card>



























    </v-card>

  </v-card>
</template>
<script>
import moment from "moment";
import { utc } from "moment/moment";
export default {
  filters: {
    //.as("seconds")
    formatDate: function (value) {
      if (value) {
        return moment(utc(value).format("YYYY-MM-DD HH:mm"));
      } else {
        return " - ";
      }
    },
    formatDuration: function (value) {
      if(value === null){
        return "0";
      }else if(value < 60){
        return moment(utc(parseFloat(value)*1000 ))
        .format("ss[s]");
      }else if(value < 3600){
        return moment(utc(parseFloat(value)*1000 ))
        .format("mm[m] ss[s]");
      }else{
        return moment(utc(parseFloat(value)*1000 ))
        .format("hh[h] mm[m] ss[s]");
      }

    },
  },
    data: () =>({
      b_NARVAL:false,
      b_SPIP:false,

      tel:{
        lastpos:{"timestamp":"2073-04-01T00:00:00.000Z","st":"12h00m00s","ah":"+6h00m00s","ra":0.0,"dec":0.0,"airmass":0,"telmarche":0,"date":"2073-04-01","time":"00:00:00"},
        targets:[]
      },
      ots :[],
      ot :{},
      og_ot_nuit :{},
      ot_encours :{},

      title: "Encours",
      dialog:"",
      search:"",
      target:{},
      A_Update_targets : null,
      A_local_load : null,

      ot_encours:{},
      objet :"",
      ra:"",
      dec:"",

      instrument : "tbl"
    }),
    initialize(){

    },
  created(){
    
  },
  beforeMount(){
     

  },
  mounted(){



    this.A_local_load = setInterval(() =>{
      this.tel        = JSON.parse(JSON.stringify(g.info.tel));
      this.ots        = JSON.parse(JSON.stringify(g.info.ots));
      //this.ot         = JSON.parse(JSON.stringify(g.info.ots[0]));
      this.og_ot_nuit = JSON.parse(JSON.stringify(g.info.og_ot_nuit));
      this.ot_encours = JSON.parse(JSON.stringify(g.info.obs_encours));
      for(var ot_t of this.ots){
        if(this.og_ot_nuit.id_og == ot_t.id_og)this.ot = ot_t;
      }
      this.instrument = this.ot_encours.instrument;
      switch(this.ot_encours.instrument){
        case 'vis':
          this.b_NARVAL = true;
          this.b_SPIP   = false; 
          break;
        case 'full':
          this.b_NARVAL = true;
          this.b_SPIP   = true; 
          break;
        case 'ir':
          this.b_NARVAL = false;
          this.b_SPIP   = true; 
          break;
        default:
          this.b_NARVAL = false;
          this.b_SPIP   = false; 
          break;
      }
    },(500));
  },
  destroyed: function () {
    clearInterval(this.A_Local_load);
  },
  
  methods: {


  }
}
</script>